export const NAV_COLOR = '#f9f6f3'
export const NAV_HEIGHT = 96
